module.exports = __webpack_public_path__ + "img/tailor-made.245fe407.jpg";